import React, {
    FC, SyntheticEvent, useState, memo,
} from 'react';

import { useTranslation } from 'react-i18next';

import { SpInput } from '@/components/Common/Sp';
import PasswordValidation from '../../Common/PasswordValidation';
import AuthSubmitButton from '../AuthSubmitButton';
import { BaseAuthLink } from '../AuthLink';
import styles from './ForgotPassword.module.scss';

const nameSpace = 'forgotPassword.secondStep';

interface PasswordWithValidation {
    value: string;
    isValid: boolean;
}

interface CreateNewPasswordProps {
    onSubmit: (e: SyntheticEvent, code: string, newPassword: string) => void;
    doForgotPassword: (e: SyntheticEvent) => void;
    goBack: () => void;
}

const CreateNewPassword: FC<CreateNewPasswordProps> = ({ onSubmit, doForgotPassword, goBack }) => {
    const { t } = useTranslation();
    const [code, setCode] = useState<string>('');
    const [passwordWithValidation, setPasswordWithValidation] = useState<PasswordWithValidation>({
        value: '', isValid: false,
    });

    const changePassword = (value: string, isValid: boolean): void => setPasswordWithValidation({
        value, isValid,
    });

    const checkIsFormValid = (): boolean => !!code.length && passwordWithValidation.isValid;

    const handleSubmit = (event: SyntheticEvent): void => onSubmit(event, code, passwordWithValidation.value);

    return (
        <div>
            <div className={styles['forgot-info']}>
                {t(`${nameSpace}.title`)}
            </div>
            <form onSubmit={handleSubmit}>
                <SpInput
                    data-testid="forgotPassword_codeInput"
                    type="text"
                    value={code}
                    placeholder={t(`${nameSpace}.placeholder`)}
                    required
                    onChange={setCode}
                    autoComplete="off"
                />
                <PasswordValidation password={passwordWithValidation.value} updateInput={changePassword} />
                <AuthSubmitButton
                    data-testid="forgotPassword_changePasswordButton"
                    isLimitedWidth
                    disabled={!checkIsFormValid()}
                    onClick={handleSubmit}
                    titleKey={`${nameSpace}.changePassword`}
                />
            </form>
            <BaseAuthLink data-testid="forgotPassword_resendLink" onClick={doForgotPassword}>
                {t(`${nameSpace}.resend`)}
            </BaseAuthLink>
            <BaseAuthLink data-testid="forgotPassword_backLink" onClick={goBack}>
                {t(`${nameSpace}.toPrevStep`)}
            </BaseAuthLink>
        </div>
    );
};

export default memo(CreateNewPassword);
